<template>
<div id="app">
  <v-app id="inspire">
    <v-snackbar
       :color="alert.type"
       :timeout="alert.type === 'error' ? 0 : 6000"
       v-model="alert.show"
       top
       >
      <v-icon>{{icon}}</v-icon>
      {{alert.message || serverError}}
      <v-btn dark flat @click.native="alert.show = false">
        <v-icon>
          close
        </v-icon>
      </v-btn>
    </v-snackbar>
    <router-view/>
  </v-app>
</div>
</template>

<script>
import { mapState } from 'vuex';

const serverError = 'サーバでエラーが発生しました。しばらく経ってから再度お試しください';

export default {
  name: 'App',
  data() {
    return {
      serverError,
    };
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
    }),
    icon() {
      switch (this.alert.type) {
        case 'info':
          return 'info';
        case 'error':
          return 'warning';
        case 'success':
          return 'check_circle';
        case 'warning':
          return 'priority_high';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.spinelab-website-front {
    .btn {
        padding: 0px 0px;
    }
    .column {
        float: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue